export type MobileHeroBanner = {
    id: number | string;
    image: string;
    alt: string;
    eyebrow: string;
    label: string;
};

export type MobileShowcaseItem = {
    id?: string;
    name: string;
    image: string;
};

export type MobileShowcaseCard = {
    id: string;
    title: string;
    kicker: string;
    theme: string;
    items: MobileShowcaseItem[];
};

/** Static fallback banners (used when no storefrontAds are loaded). */
export const mobileHeroBannersFallback: MobileHeroBanner[] = [
    {
        id: 1,
        image: "/assets/images/banner/banner-1.jpg",
        alt: "Salar shopping banner",
        eyebrow: "SALAR SELECT",
        label: "Shopping picks for today",
    },
    {
        id: 2,
        image: "/assets/images/banner/banner-2.jpg",
        alt: "Salar electronics banner",
        eyebrow: "TECH DROP",
        label: "Upgrade your everyday",
    },
    {
        id: 3,
        image: "/assets/images/banner/banner-3.jpg",
        alt: "Salar fashion banner",
        eyebrow: "STYLE EDIT",
        label: "Fresh looks, easy picks",
    },
];

/** Static fallback showcase cards (used when no API data is available). */
export const mobileShowcaseCardsFallback: MobileShowcaseCard[] = [
    {
        id: "continue",
        title: "Pick up where you left off",
        kicker: "CONTINUE SHOPPING",
        theme: "blue",
        items: [
            { name: "Samsung Galaxy S25 Ultra", image: "/assets/images/ban-pro/ban-pro-1.png" },
            { name: "Samsung Galaxy S25", image: "/assets/images/ban-pro/ban-pro-2.png" },
            { name: "iPhone 16", image: "/assets/images/ban-pro/ban-pro-3.png" },
            { name: "OnePlus 13", image: "/assets/images/ban-pro/ban-pro-4.png" },
        ],
    },
    {
        id: "women",
        title: "Keep shopping for",
        kicker: "YOUR RECENT INTERESTS",
        theme: "rose",
        items: [
            { name: "Women's Dresses", image: "/assets/images/ban-pro/ban-pro-5.png" },
            { name: "Fashion Lifestyle", image: "/assets/images/ban-pro/ban-pro-6.png" },
            { name: "Women's Tops", image: "/assets/images/ban-pro/ban-pro-7.png" },
            { name: "Lifestyle", image: "/assets/images/ban-pro/ban-pro-8.png" },
        ],
    },
    {
        id: "men",
        title: "Men's fashion deals",
        kicker: "TRENDING FOR YOU",
        theme: "sand",
        items: [
            { name: "Printed Shirts", image: "/assets/images/ban-pro/ban-pro-9.png" },
            { name: "Trending Shirts", image: "/assets/images/ban-pro/ban-pro-10.png" },
            { name: "Check Shirts", image: "/assets/images/ban-pro/ban-pro-11.png" },
            { name: "Formal Shirts", image: "/assets/images/ban-pro/ban-pro-12.png" },
        ],
    },
    {
        id: "grocery",
        title: "Up to 60% off on Groceries",
        kicker: "DAILY PANTRY DEALS",
        theme: "fresh",
        items: [
            { name: "Marie Lite", image: "/assets/images/ban-pro/ban-pro-13.png" },
            { name: "Tata Tea Gold", image: "/assets/images/ban-pro/ban-pro-14.png" },
            { name: "Vedaka Grains", image: "/assets/images/ban-pro/ban-pro-15.png" },
            { name: "Clove", image: "/assets/images/ban-pro/ban-pro-16.png" },
        ],
    },
    {
        id: "explore",
        title: "Explore something new",
        kicker: "DISCOVER ON SALAR",
        theme: "violet",
        items: [
            { name: "Mobiles & Accessories", image: "/assets/images/ban-pro/ban-pro-1.png" },
            { name: "Women Fashion", image: "/assets/images/ban-pro/ban-pro-18.png" },
            { name: "Men Fashion", image: "/assets/images/ban-pro/ban-pro-9.png" },
            { name: "Home & Appliances", image: "/assets/images/ban-pro/ban-pro-17.png" },
        ],
    },
];
